<template>
  <div class="cta-button" v-if="$store.getters.canVote">
    <a @click="onVote"
       :href="voteLink"
       target="_blank">Vote now <i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>
  </div>
</template>

<script>
export default {
  props: {
    voteLink: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      votingOn: true
    }
  },
  computed: {
    votingLink () {
      return this.$store.getters.votingLink
    }
  },
  methods: {
    onVote (event) {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/VoteNow.vue